import { SharedState } from "../../SharedProvider";

export const selectCurrentTeaching = (state: SharedState) => state.rooms.teaching.currentTeaching;
